import {CircularProgress} from '@mui/material'
import DataRefetchOnError from '../../common/DataFetchError/DataRefetchOnError'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {DropdownLoadingBox} from './JurisdictionStyle'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import PropTypes from 'prop-types'
import {StyledSectionTitle} from '../../AdminPanelStyling'

const JurisdictionComponent = ({selectedData, setJurisdictionValue, enabled, isCompleted}) => {
  JurisdictionComponent.propTypes = {
    selectedData: PropTypes.array.isRequired,
    setJurisdictionValue: PropTypes.func.isRequired,
    enabled: PropTypes.bool.isRequired,
    isCompleted: PropTypes.bool.isRequired
  }

  const {jurisdiction, filterDetailsLoading, filterDetailsError, refetchFilterDetailsList} = useProjectDetails()

  function refetchJurisdictionStates(event) {
    event.preventDefault()
    refetchFilterDetailsList()
  }

  if (filterDetailsLoading) {
    return (
      <>
        <StyledSectionTitle variant='h5'>{"What's the jurisdiction area(s) for this project?"}</StyledSectionTitle>
        <DropdownLoadingBox>
          <CircularProgress />
        </DropdownLoadingBox>
      </>
    )
  }
  return (
    <>
      <StyledSectionTitle variant='h5'> {"What's the jurisdiction area(s) for this project?"} </StyledSectionTitle>
      {!filterDetailsLoading && filterDetailsError ? (
        <DataRefetchOnError onTryAgain={(event) => refetchJurisdictionStates(event)} />
      ) : (
        <MultiSelectDropdownComponent
          selectAllTitle='Entire United States'
          dropDownTitle='Select State'
          inputAndPreviewTitle='Jurisdiction(s)'
          dropDownModifiedTitle='Selected Jurisdictions'
          dropDownData={jurisdiction}
          val={selectedData}
          setVal={setJurisdictionValue}
          enabled={enabled}
          isCompleted={isCompleted}
        />
      )}
    </>
  )
}

export default JurisdictionComponent
